import { lazy } from 'react';

export const PlayerInstantBankingForm = lazy(
  () => import('./PlayerInstantBankingForm'),
);
